/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePeriodRequest } from '../../models/create-period-request';
import { PeriodResponse } from '../../models/period-response';

export interface CreatePeriod$Params {
      body: CreatePeriodRequest
}

export function createPeriod(http: HttpClient, rootUrl: string, params: CreatePeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<PeriodResponse>> {
  const rb = new RequestBuilder(rootUrl, createPeriod.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PeriodResponse>;
    })
  );
}

createPeriod.PATH = '/v0/explore-graph/periods';
